<script lang="ts">
  import { Heading, Paragraph } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;

  const arrow = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" style="fill:currentColor"><path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path></svg>`;
</script>

<section>
  <div class="container">
    <iframe
      style="min-height:unset;"
      src="https://lottie.host/?file=84ea3257-b58c-4895-89e0-bbb4bfcb66e1/C1xuDnapZ6.json"
      title="lottie"
      frameborder="0"
    />
    <Heading
      type={'h1'}
      css={'margin-top:10px;margin-bottom:15px;color:var(--vlt-lp-text);'}
      >404: {properties?.headline}</Heading
    >
    <Paragraph css={'margin-bottom:30px;color:var(--vlt-lp-text);'}
      >Sorry, the page you're looking for doesn't exist.</Paragraph
    >
    <Heading
      type={'h2'}
      css={'margin-top:10px;margin-bottom:15px;color:var(--vlt-lp-text);font-size:18px;'}
      >Did you mean?</Heading
    >
    <ul>
      {#each properties.links.items as { label, url, type }}
        {#if type !== 'Button'}
          <li>
            <a href={type === 'Section' ? `/#${url}` : url}>
              {@html arrow}
              {label}
            </a>
          </li>
        {/if}
      {/each}
    </ul>
  </div>
</section>

<style>
  section {
    width: 100%;
    padding: 50px 0;
    background-color: var(--vlt-lp-background);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .container {
    width: 100%;
    max-width: 900px;
    padding: 25px;
    box-sizing: border-box;
    text-align: left;
  }
  iframe {
    display: block;
    height: auto;
    transform: scale(1.5);

    width: auto;
    margin: 0 auto 50px;
  }
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    padding: 6px 0;
  }
  a {
    display: inline-flex;
    align-items: center;
    grid-gap: 6px;
    text-decoration: none;
    color: var(--vlt-lp-primary);
  }
  @media screen and (max-width: 583px) {
    iframe {
      transform: scale(1);
    }
  }
</style>
